import { Scope, useScopes } from 'app/scopes'

type Props = Readonly<{
  scopes: Array<Scope>
  children: JSX.Element
}>

export const ProtectedRoute = ({ scopes, children }: Props) => {
  const userScopes = useScopes()

  if (scopes.length === 0) {
    return children
  }

  if (!scopes.every(scope => userScopes[scope])) {
    return <p>Access denied</p>
  }

  return children
}
